import logoGreen from '../assets/logo-green.png';
import { TOOLS, ToolId } from '../data/tools';

// Two concentric rings of tool logos. Order matters visually — spread the
// Microsoft-heavy items around so no arc reads as "all blue".
const OUTER: ToolId[] = [
  'copilot-studio',
  'power-bi',
  'openai',
  'power-automate',
  'claude',
  'dataverse',
  'n8n',
  'azure-openai',
  'gemini',
  'fabric',
  'uipath',
  'azure-devops',
];

const INNER: ToolId[] = [
  'power-platform',
  'azure-ai-services',
  'microsoft-365',
  'logic-apps',
  'ai-builder',
  'make',
  'azure-data-factory',
  'ms-project',
];

function Ring({ ids, className }: { ids: ToolId[]; className: string }) {
  const step = 360 / ids.length;
  return (
    <div className={`hero-orbit-ring ${className}`}>
      {ids.map((id, i) => {
        const tool = TOOLS[id];
        return (
          <div
            className="hero-orbit-item"
            key={id}
            style={{ '--angle': `${i * step}deg` } as React.CSSProperties}
          >
            <div
              className="tool-chip-logo hero-orbit-chip"
              data-tip={tool.name}
              tabIndex={0}
              aria-label={tool.name}
            >
              {tool.logo ? (
                <img src={tool.logo} alt="" />
              ) : (
                <span className="tool-chip-mono">{tool.monogram}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/** Hero visual: the tools we build on, orbiting the EightyThreeLabs mark. */
function HeroOrbit() {
  return (
    <div className="hero-orbit" aria-label="Tools and platforms we build on">
      <div className="hero-orbit-halo hero-orbit-halo-outer" aria-hidden="true" />
      <div className="hero-orbit-halo hero-orbit-halo-inner" aria-hidden="true" />
      <Ring ids={OUTER} className="hero-orbit-ring-outer" />
      <Ring ids={INNER} className="hero-orbit-ring-inner" />
      <div className="hero-orbit-center" aria-hidden="true">
        <img src={logoGreen} alt="" />
      </div>
    </div>
  );
}

export default HeroOrbit;
